module.exports = __webpack_public_path__ + "static/media/video-stress-es.35662bd8.vtt";